import React from 'react';
import Panel from '../../../../../components/outline/Panel';
import InputForm from '../../../../../components/form/InputForm';
import { REX_EXTRA_PHONE, REX_NAME, REX_PHONE } from '../../../../../lib/rex';
import { setClearDash, setPhoneFormat } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import { AMONDZ_MEMBER_TYPE } from '../../../../../constants/service/common/utilConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import './BrandDetailInfoSeller.scss';

const BrandDetailInfoSeller = (props) => {
  const { data, form, setData, storeId, isEditable } = props;
  const { email, name, phone, extraPhone } = data;

  return (
    <Panel className="brand-detail-info-seller">
      <div className="panel-header">
        <div className="title">담당자 정보</div>
      </div>

      <div className="panel-body">
        {/*이메일*/}
        <InputForm
          label="이메일"
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, REQUIRED_MSG), { type: 'email', message: '이메일을 확인해주세요!' }]}
          initialValue={email}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'sellerInfo', 'email'],
              value,
            })
          }
          name="email"
        />

        {/*이름*/}
        <InputForm
          label="이름"
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, REQUIRED_MSG), { pattern: REX_NAME, message: '이름을 확인해주세요!' }]}
          initialValue={name}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'sellerInfo', 'name'],
              value,
            })
          }
          name="name"
        />

        {/*핸드폰*/}
        <InputForm
          label="핸드폰"
          form={form}
          isEditable={isEditable}
          rules={[formRequiredRules(true, REQUIRED_MSG), { pattern: REX_PHONE, message: '핸드폰 번호를 확인해주세요' }]}
          initialValue={setPhoneFormat(phone)}
          alterForm={
            <SendMessageService
              text={setPhoneFormat(phone)}
              memberType={AMONDZ_MEMBER_TYPE.SELLER}
              targetId={storeId}
            />
          }
          getValueFromEvent={(value) => setPhoneFormat(value)}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'sellerInfo', 'phone'],
              value: setClearDash(value),
            })
          }
          name="phone"
        />

        {/*유선전화*/}
        <InputForm
          label="유선전화"
          form={form}
          isEditable={isEditable}
          rules={[{ pattern: REX_EXTRA_PHONE, message: '유선전화번호 형식이 잘못되었습니다!' }]}
          initialValue={setPhoneFormat(extraPhone)}
          getValueFromEvent={(value) => setPhoneFormat(value)}
          onChange={(value) =>
            setData({
              path: ['brandDetail', 'info', 'sellerInfo', 'extraPhone'],
              value: setClearDash(value),
            })
          }
          name="extraPhone"
        />
      </div>
    </Panel>
  );
};

export default BrandDetailInfoSeller;
